import { render, staticRenderFns } from "./carry_on.vue?vue&type=template&id=0c08288c&"
import script from "./carry_on.vue?vue&type=script&lang=js&"
export * from "./carry_on.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports